import React, { useState } from "react";
import KickImage from 'Reuseables/KickImage';
import { Row, Col, Collapse } from "react-bootstrap"

/* UTILS/ HELPERS */
import {
  DEFAULT_CREDIT_CARD,
  DEFAULT_PAYMENT_METHOD,
} from "../../../constants/paymentMethods"

import { emptyImage, getCloudImageUrl, convertToRupiah } from "../../../utils"

/* INTERFACES */
import { 
  balanceUsage
} from "../Interfaces"

/* ASSETS */
import CircleBack from "../../../images/circle-back.png";
import ArrowsNext from "../../../images/arrowsNext.png";
import ArrowDown from "../../../images/arrowDown.png"

const CircleBackIcon: any = CircleBack
const ArrowsNextIcon: any = ArrowsNext
const ArrowDownIcon: any = ArrowDown

interface paymentMethod {
  type?: string;
  logo?: string;
  label?: string;
  active?: boolean;
  payment_group?: number;
  payment_method?: string;
}

interface size {
  US: string
}

type ChoosePaymentProcessProps = {
  size: size
  etaText: string
  adminFee: number
  inputOffer: string
  emptyImage: any
  balance: string
  balance_with_fee: string
  dataAkulaku: Array<Object>
  _shippingFee: number
  balanceUsage: balanceUsage
  isIndonesian: string
  shippingCountry: string
  totalBalance: number
  isSplitPayment: boolean
  productImage: string
  locked_balance: string
  display_name: string
  amountToBePaid: string
  creditDebitOnly: boolean
  _paymentMethods: Array<paymentMethod>
  productCondition: string
  isOpenModalBalanceInfo: boolean
  setMakeOfferProcess: (args: string) => void
  setIsSplitPayment: (params: boolean) => void
  setCurrentPaymentMethod: (item: paymentMethod) => void
  setIsOpenInsuficientBalance: (args: boolean) => void
}

const ChoosePaymentProcess: React.FC<ChoosePaymentProcessProps> = ({
  size,
  etaText,
  adminFee,
  inputOffer,
  emptyImage,
  _shippingFee,
  isIndonesian,
  shippingCountry,
  totalBalance,
  balance,
  balance_with_fee,
  amountToBePaid,
  _paymentMethods,
  creditDebitOnly,
  productCondition,
  productImage,
  locked_balance,
  display_name,
  isSplitPayment,
  balanceUsage,
  setIsSplitPayment,
  setMakeOfferProcess,
  setCurrentPaymentMethod,
  setIsOpenInsuficientBalance
}): JSX.Element => {
  const [openCollapse, setOpenCollapse] = useState(false)

  const shipToIndonesia = shippingCountry === 'IDN'
  const availableCreditCardPayments = () => {
    let payments = _paymentMethods.filter((item) => item.payment_group === 1 && item.type === 'credit_card')

    if (!isIndonesian || !shipToIndonesia) {
      payments = payments.filter(item => item.payment_method === DEFAULT_CREDIT_CARD && item.label !== 'BCA Card')
    }

    return payments
  }

  return (
    <Col className="payment-right-bag-content">
      <div className="payment-list-scroll">
        <Row className="choose-payment-type">
          <Col
            className="icon-wrapper"
            onClick={() => setMakeOfferProcess("")}
          >
            <KickImage src={CircleBackIcon} alt="..." />
          </Col>
          <Col className="text">
            <p>Choose Payment</p>
          </Col>
        </Row>
        <Row className="amount-to-be-paid"
          onClick={() => setOpenCollapse(!openCollapse)}
        >
          <p>Amount to be paid</p>
          <p>IDR. {convertToRupiah(amountToBePaid)}</p>
          <KickImage src={ArrowDownIcon} alt="..." />
        </Row>
        <Collapse in={openCollapse}>
          <div className="make-offer-collapse-wrapper">
            <h3>Order Details</h3>
            {/* PRODUCT CARD + ADDON SELECTED */}
            <div className="product-card-container">
              <div className="product-card-wrapper">
                <div className="image-wrapper">
                  {productImage ? (
                    <KickImage src={getCloudImageUrl(productImage, 500)} alt="..." />
                  ) : (
                    <KickImage src={emptyImage} alt="..." />
                  )}
                </div>
                <div className="description-wrapper">
                  <div className="name-and-condition">
                    <p>{display_name}</p>
                    <p>
                      {size.US} / {productCondition} / {etaText}{" "}
                    </p>
                  </div>
                  <p className="input-price">IDR {convertToRupiah(parseInt(inputOffer))}</p>
                </div>
              </div>
            </div>

            {/* PAYMENT SUMMARY */}
            <div className="summary-wrapper">
              <div className="summary-details-wrapper">
                <div className="summary-row">
                  <p>Payment Summary</p>
                </div>
                <div className="summary-row">
                  <p>Offer Price</p>
                  <p>IDR. {convertToRupiah(parseInt(inputOffer))}</p>
                </div>
                <div className="summary-row">
                  <p>Administration Fee</p>
                  <p>IDR. {convertToRupiah(adminFee)}</p>
                </div>
                <div className="summary-row">
                  <p>Shipping {`&`} Handling</p>
                  <p>IDR. {convertToRupiah(_shippingFee)}</p>
                </div>
              </div>
              <div className="term-condition-wrapper">
                <p>
                  By clicking Continue, user has read and agreed to Kick Avenue{" "}
                  <span>Shipping and Returns Policy</span>
                </p>
              </div>
            </div>
          </div>
        </Collapse>
        <div className="top-box-shadow"><p></p></div>
        {/* KICK CREDIT */}
        {isIndonesian && shipToIndonesia &&
          <Row className="kick-credit-payment-wrapper">
            <div className="title-text-wrapper">
              <p>Kick Credit</p>
              <p>
                Your payment will be verified automatically by the payment gateway.
              </p>
            </div>
            {_paymentMethods.map((item, index) => {
              if (item.payment_group === 3) {
                const isNotDisable = totalBalance > 0 || !creditDebitOnly;
                return (
                  <Row
                    onClick={() => {
                      if (isNotDisable && item.active) {
                        setMakeOfferProcess("confirm-kick-credit");
                        setCurrentPaymentMethod(item);
                        setIsSplitPayment(
                          (totalBalance < parseInt(amountToBePaid)) ? true : false
                        );
                        setIsOpenInsuficientBalance(
                          (totalBalance < parseInt(amountToBePaid)) ? true : false
                        );
                      }
                    }}
                    className={`payment-list-wrapper kick-credit-wrapper ${(isNotDisable && item.active) ? "" : "disabled"
                      }`}
                  >
                    <Col className="icon-wrapper">
                      <KickImage src={getCloudImageUrl(item.logo)} alt="..." />
                    </Col>
                    <Col className="text-wrapper">
                      <p>
                        Credit Balance: IDR. <span>{convertToRupiah(parseInt(balance) + parseInt(balance_with_fee))}</span>
                      </p>
                      <p>
                        Kick Points: KP. <span>{convertToRupiah(parseInt(locked_balance))}</span>
                      </p>
                    </Col>
                    <Col className="arrow-wrapper">
                      <KickImage src={ArrowsNextIcon} alt="..." />
                    </Col>
                  </Row>
                );
              }
            })}
          </Row>
        }
        {/* CREDIT CARD */}
        <Row className="kick-credit-payment-wrapper">
          <div className="title-text-wrapper">
            <p>Credit Card</p>
            <p>
              Your payment will be verified automatically by the payment gateway.
            </p>
          </div>
          {availableCreditCardPayments().map((item, index) => {
            if (item.payment_group === 1 && item.type === "credit_card") {
              const isNotDisable =
                (item.active && isIndonesian) ||
                (!isIndonesian &&
                  item.payment_method === DEFAULT_CREDIT_CARD);
              return (
                <Row
                  onClick={() => {
                    if (isNotDisable) {
                      setCurrentPaymentMethod(item);
                      setMakeOfferProcess("confirm-others-kick-credit");
                    }
                  }}
                  className={`payment-list-wrapper virtual-account-wrapper ${isNotDisable ? "" : "disabled"
                    }`}
                >
                  <Col className="icon-wrapper">
                    {item.logo && (
                      <KickImage src={getCloudImageUrl(item.logo)} alt="..." />
                    )}
                  </Col>
                  <Col className="text-wrapper">
                    <p>{item.label}</p>
                  </Col>
                  <Col className="arrow-wrapper">
                    <KickImage src={ArrowsNext} alt="..." />
                  </Col>
                </Row>
              );
            }
          })}
        </Row>
        {/* VIRTUAL ACCOUNTS */}
        {isIndonesian && shipToIndonesia &&
          <Row className="kick-credit-payment-wrapper">
            <div className="title-text-wrapper">
              <p>Virtual Acccount</p>
              <p>
                Your payment will be verified automatically by the payment gateway.
              </p>
            </div>
            {_paymentMethods.map((item, index) => {
              if (
                item.payment_group === 1 &&
                item.type === "virtual_account"
              ) {
                const isNotDisable = item.active && isIndonesian;
                return (
                  <Row
                    onClick={() => {
                      if (isNotDisable) {
                        setMakeOfferProcess("confirm-others-kick-credit");
                        setCurrentPaymentMethod(item);
                      }
                    }}
                    className={`payment-list-wrapper virtual-account-wrapper ${isNotDisable ? "" : "disabled"
                      }`}
                  >
                    <Col className="icon-wrapper">
                      {item.logo && (
                        <KickImage src={getCloudImageUrl(item.logo)} alt="..." />
                      )}
                    </Col>
                    <Col className="text-wrapper">
                      <p>{item.label}</p>
                    </Col>
                    <Col className="arrow-wrapper">
                      <KickImage src={ArrowsNext} alt="..." />
                    </Col>
                  </Row>
                );
              }
            })}
          </Row>
        }
        {/* <Row className="kick-credit-payment-wrapper">
          <div className="title-text-wrapper">
            <p>Bank Transfer - Manual Verification</p>
            <p>
              Please allow 1 working day for us to verify your payment.
            </p>
          </div>
          {_paymentMethods.map((item, index) => {
            if (
              item.payment_group === 1 &&
              item.type === "bank_transfer"
            ) {
              const isNotDisable = item.active && isIndonesian;
              return (
                <Row
                  onClick={() => {
                    if (isNotDisable) {
                      setMakeOfferProcess("confirm-others-kick-credit");
                      setCurrentPaymentMethod(item);
                    }
                  }}
                  className={`payment-list-wrapper virtual-account-wrapper ${isNotDisable ? "" : "disabled"
                    }`}
                >
                  <Col className="icon-wrapper">
                    {item.logo && (
                      <KickImage src={getCloudImageUrl(item.logo)} alt="..." />
                    )}
                  </Col>
                  <Col className="text-wrapper">
                    <p>{item.label}</p>
                  </Col>
                  <Col className="arrow-wrapper">
                    <KickImage src={ArrowsNext} alt="..." />
                  </Col>
                </Row>
              );
            }
          })}
        </Row> */}
      </div>
    </Col>
  )
}

export default ChoosePaymentProcess